const QuizzWithImageAndOptions = ({ quizz }) => {
    return (
        <>
            <div className='QuizzWithImageAndOptions__Screen__Background'>
                {quizz?.isActiveWomensMode ? (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='FrontPage__Screen__Background__Image' />
                ) : (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Varonil.png' className='FrontPage__Screen__Background__Image' />
                )}
            </div>

            <div className='QuizzWithImageAndOptions__Screen'>
                <div className="QuizzWithImageAndOptions__Screen__Top">
                    {/* <img src='/img/page/adsl-five.png' className='QuizzWithImageAndOptions__Screen__Logo' /> */}
                    <p className='QuizzWithImageAndOptions__Screen__Title'>{quizz.instruction}</p> {/* Fonts--RoughStroke */}
                </div>

                <div className='QuizzWithImageAndOptions__Screen__Container--Hidden'>
                    <img src={quizz.image} className='QuizzWithImageAndOptions__Screen__Container--Hidden__Image' />

                    <ul className='QuizzWithImageAndOptions__Screen__Container--Hidden__List'>
                        {quizz.options.map((option, index) => (
                            <li key={index} className='QuizzWithImageAndOptions__Screen__Container--Hidden__List__Item'>{option.text}</li> //{/* Fonts--RoughStroke */}
                        ))}
                    </ul>
                </div>
            </div>

            <footer className='QuizzWithImageAndOptions__Screen__Footer FooterCredits'>
                Hecho con ♥ por Five Digital Minds | 2026
            </footer>
        </>
    )
}

export { QuizzWithImageAndOptions };